// extracted by mini-css-extract-plugin
export var currencyInput = "_lg-1";
export var currencySymbol = "_lg-0";